export default "__VITE_ASSET__6f1364a5__"